import React from 'react';

import i18n from 'i18next';

import { Typo } from 'uikit/content';

import getInitiativeTypeLabel from '../helpers/getInitiativeTypeLabel';

import InitiativeWizardSummaryCard from './initiativeWizardSummaryCard';

import styles from '../styles/initiativeWizardSummary.module.scss';

const InitiativeWizardSummary = ({ errors, model, onEditButtonClick }) => (
  <div className={styles.element}>
    <Typo className={styles.title}>{i18n.t('initiative-summary-title')}</Typo>
    <Typo className={styles.body} color="secondary">
      {i18n.t('initiative-summary-body')}
    </Typo>
    <div className={styles.cards}>
      <InitiativeWizardSummaryCard
        title={i18n.t('initiative-name')}
        error={errors.name}
        body={model.name}
        onEditButtonClick={() => onEditButtonClick(0)}
      />
      <InitiativeWizardSummaryCard
        title={i18n.t('initiative-type')}
        error={errors.initiative_type}
        body={getInitiativeTypeLabel(model.initiative_type)}
        onEditButtonClick={() => onEditButtonClick(0)}
      />
      <InitiativeWizardSummaryCard
        title={i18n.t('initiative-description')}
        error={errors.description}
        body={model.description}
        hasMarkdown
        onEditButtonClick={() => onEditButtonClick(0)}
      />
      <InitiativeWizardSummaryCard
        title={i18n.t('audiences')}
        error={errors.audiences}
        body={model.audiences?.map(({ name }) => name).join(', ')}
        onEditButtonClick={() => onEditButtonClick(1)}
      />
      <InitiativeWizardSummaryCard
        title={i18n.t('additional-tracking')}
        error={errors.social_tracking || errors.ecommerce_tracking || errors.live_tracking}
        body={[
          model.social_tracking && i18n.t('social'),
          model.ecommerce_tracking && i18n.t('ecommerce'),
          model.live_tracking && i18n.t('instructor-led'),
        ]
          .filter(Boolean)
          .join(', ')}
        onEditButtonClick={() => onEditButtonClick(2)}
      />
    </div>
  </div>
);

export default React.memo(InitiativeWizardSummary);
